import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import "../styles/homepage.css";
import Slider from "./homepage/Slider";
import Footer from "./homepage/Footer";

function Homepage() {
  const auth = localStorage.getItem("user");
  const user = JSON.parse(auth);
  const userName = (user && user[0] && user[0].name) || "DefaultName";

  const type = (user && user[0] && user[0].userType) || "Default";

  const navigate = useNavigate();
  const logout = () => {
    localStorage.clear();
    navigate("/");
  };
  return (
    <div className="roots ">
      {/* Navbar */}
      <header id="home" className="m-4">
        <div className="left">
          <h2>
            <span>in</span>Force
          </h2>
        </div>
        <div className="right">
          <NavLink className="links active p-2" to="/">
            Home
          </NavLink>
          <NavLink className="links p-2" type="button" to="/laws">
            Traffic Violations
          </NavLink>

          <NavLink className="links p-2" type="button" to="/policestation">
            Police Stations
          </NavLink>
          {auth ? (
            <NavLink
              className="btn btn-outline-light"
              type="button"
              id="form-open"
              to="/"
              onClick={logout}
            >
              Logout({userName})
            </NavLink>
          ) : (
            <NavLink
              className="btn btn-outline-light"
              type="button"
              to="/login"
            >
              Login
            </NavLink>
          )}
          {/* {(auth && (type === "admin" || type === "super") )? (
                <NavLink
                  className="btn btn-outline-light"
                  type="button"
        
                  to="/tc/dashboard"    
                >
                  <i className="fa-solid fa-bars"></i>
                </NavLink>
              ) : (
                <NavLink
                  className="btn btn-outline-light"
                  type="button"
                  
                  to="/driver/dashboard"
                >
                  <i className="fa-solid fa-bars"></i>
                </NavLink>
              )}  */}
        </div>
      </header>

      <main className="text-white">
        {/* Slider */}
        <section id="section1">
          <Slider />
        </section>
        {/* Some Updates */}
        <section id="section2">
          <h2 className="text-center pb-2">Traffic Updates</h2>
          <div id="carouselExampleDark" class="carousel carousel-dark slide ">
            <div class="carousel-indicators">
              <button
                type="button"
                data-bs-target="#carouselExampleDark"
                data-bs-slide-to="0"
                class="active"
                aria-current="true"
                aria-label="Slide 1"
              ></button>
              <button
                type="button"
                data-bs-target="#carouselExampleDark"
                data-bs-slide-to="1"
                aria-label="Slide 2"
              ></button>
              <button
                type="button"
                data-bs-target="#carouselExampleDark"
                data-bs-slide-to="2"
                aria-label="Slide 3"
              ></button>
            </div>
            <div class="carousel-inner">
              <div class="carousel-item active" data-bs-interval="10000">
                <img
                  src="car.jpeg"
                  class="d-block w-100 rounded"
                  alt="Vehicle Condition"
                />
                <div class="carousel-caption d-none d-md-block text-white rounded">
                  <h5>Vehicle Condition</h5>
                  <p className="p-2">
                    Before registering a vehicle, its eligibility must be
                    confirmed. Operating a vehicle in poor condition is illegal
                    and unsafe, posing risks to the environment and public
                    roads. Therefore, passing a safety inspection is mandatory.
                    Using a forged or expired roadworthiness certificate is also
                    against the law. Section 25 of the 2018 Road Transport Act
                    stipulates prosecution for issuing certificates to unfit
                    vehicles. Additionally, every motor vehicle owner must pay
                    government taxes as mandated by the 1932 Motor Vehicles Tax
                    Act (Section 26).
                  </p>
                </div>
              </div>
              <div class="carousel-item text-white" data-bs-interval="2000">
                <img src="road.jpg" class="d-block w-100 rounded" alt="Route Permit" />
                <div class="carousel-caption d-none d-md-block text-white rounded">
                  <h5>Route Permit</h5>
                  <p className="p-2">
                    The route authorization will be granted by the
                    transportation committee. Unless authorized by the
                    transportation committee, the vehicle owner is prohibited
                    from driving on public roads or allowing others to do so. If
                    the route permit is not properly explained, section 28
                    stipulates the following conditions.
                  </p>
                </div>
              </div>
              <div class="carousel-item text-white">
                <img
                  src="victim.jpeg"
                  class="d-block w-100 rounded"
                  alt="Restitution to the Victim"
                />
                <div class="carousel-caption d-none d-md-block text-white rounded">
                  <h5>Restitution to the Victim or His or Her Family</h5>
                  <p className="p-2">
                    A person is entitled to compensation under Section 53 of the
                    Road Transport Act 2018 if he is injured, his property is
                    damaged, or he dies unnaturally as a result of a motor
                    vehicle.
                  </p>
                </div>
              </div>
            </div>
            <button
              class="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleDark"
              data-bs-slide="prev"
            >
              <span
                class="carousel-control-prev-icon rounded-circle"
                aria-hidden="true"
              ></span>
              <span class="visually-hidden ">Previous</span>
            </button>
            <button
              class="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleDark"
              data-bs-slide="next"
            >
              <span
                class="carousel-control-next-icon rounded-circle"
                aria-hidden="true"
              ></span>
              <span class="visually-hidden">Next</span>
            </button>
          </div>
        </section>
        {/* FAQ */}
        <section className="text-white mx-4" id="section3">
          <h2 className="text-center pb-2">Frequently Asked Questions</h2>
          <div class="accordion" id="accordionExample">
            <div class="accordion-item">
              <h2 class="accordion-header">
                <button
                  class="accordion-button"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseOne"
                  aria-expanded="true"
                  aria-controls="collapseOne"
                >
                  How can I access the system?
                </button>
              </h2>
              <div
                id="collapseOne"
                class="accordion-collapse collapse show"
                data-bs-parent="#accordionExample"
              >
                <div class="accordion-body  text-white">
                  To access the system, you need to register for an account. If
                  you're a driver, you can sign up using your driving and
                  personal information. Traffic officers can register using
                  their official credentials.
                </div>
              </div>
            </div>
            <div class="accordion-item">
              <h2 class="accordion-header">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseTwo"
                  aria-expanded="false"
                  aria-controls="collapseTwo"
                >
                  Can I track multiple cases at once?
                </button>
              </h2>
              <div
                id="collapseTwo"
                class="accordion-collapse collapse"
                data-bs-parent="#accordionExample"
              >
                <div class="accordion-body  text-white">
                  Yes, both drivers and traffic officers can track multiple
                  cases simultaneously, providing a comprehensive overview of
                  their case history.
                </div>
              </div>
            </div>
            <div class="accordion-item">
              <h2 class="accordion-header">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseThree"
                  aria-expanded="false"
                  aria-controls="collapseThree"
                >
                  How often is the system updated?
                </button>
              </h2>
              <div
                id="collapseThree"
                class="accordion-collapse collapse"
                data-bs-parent="#accordionExample"
              >
                <div class="accordion-body text-white">
                  The system is regularly updated to improve functionality,
                  security, and user experience. Updates are rolled out with
                  minimal disruption to users.
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <footer>
        <Footer />
      </footer>
    </div>
  );
}

export default Homepage;
